module.exports = __webpack_public_path__ + "img/arr.264daaab.svg";